import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import DesktopLayerPopup from '../../../common/DesktopLayerPopup';
import PostNumber from '../../../common/components/PostNumber';
import Timer from '../../../common/components/Timer';
import OnetimeConfirmContent from '../../../common/components/OnetimeConfirmContent';
import { RegExp } from '../../../../library/constants/RegExp';

const supporterDefault = '기타';

const ShippingAddressNotLogin = ({
    certStatus,
    onChangeCertStatus,
    user_info,
    setUserInfo,
    buttonBlock,
    clearAction,
    checkOneTimePasswordForMemberJoin,
    phoneDuplicateCheckAndOneTimePasswordForMemberJoin,
    existAuth,
    auth,
    actor,
    action, //?
    mdn_token,
}) => {
    const inputRef = useRef({
        human_postal_code: null,
        human_address: null,
        human_detail_address: null,
    });

    const timeoutIdRef = useRef(null);
    const layerPopupKeyRef = useRef(null);

    const [userInfo, setLocalUserInfo] = useState({});
    const [timerOn, setTimerOn] = useState(false);
    const [supporter, setSupporter] = useState(supporterDefault);

    useEffect(() => {
        const compUserInfo = {
            ...user_info,
            supporter: supporterDefault,
        };
        setUserInfo(compUserInfo);
        setLocalUserInfo(compUserInfo);

        return () => {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
                timeoutIdRef.current = null;
            }
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const compUserInfo = {
            ...user_info,
            supporter,
        };
        setLocalUserInfo(compUserInfo);
        // eslint-disable-next-line
    }, [user_info]);

    useEffect(() => {
        if (!action) return;
        switch (action) {
            case 'PhoneDuplicate':
                buttonBlock?.current?.stop();
                clearAction?.();
                timeoutIdRef.current = setTimeout(() => {
                    DesktopLayerPopup.notice({
                        message: '이미 가입된 휴대전화번호 입니다.',
                    });
                }, 500);
                break;

            // 인증번호 발송 성공
            case 'successOneTimePassword':
                buttonBlock?.current?.stop();
                clearAction?.();
                timeoutIdRef.current = setTimeout(() => {
                    setTimerOn(true);
                    onChangeCertStatus?.({
                        onTimePasswordCount: (certStatus.onTimePasswordCount ?? 0) + 1,
                        certificationNumber: '',
                    });
                }, 500);
                break;

            // 인증번호 확인 성공
            case 'successCheckOneTimePassword':
                setTimerOn(false);
                onChangeCertStatus?.({
                    mdn_token,
                    complete: true,
                });
                if (existAuth === true && auth && auth.id) {
                    let parent_category_tag_name;
                    if (['엄마', '아빠', '할머니', '할아버지', '기타'].indexOf(actor?.category_tag_name) !== -1) {
                        parent_category_tag_name = actor.category_tag_name;
                    } else {
                        parent_category_tag_name = '기타';
                    }

                    setUserInfo?.({
                        ...user_info,
                        human_postal_code: auth.human_postal_code,
                        human_address: auth.human_address,
                        human_detail_address: auth.human_detail_address,
                        supporter: parent_category_tag_name,
                    });
                    setSupporter(parent_category_tag_name);

                    if (inputRef.current.human_detail_address) {
                        inputRef.current.human_detail_address.value = auth.human_detail_address || '';
                    }
                }
                buttonBlock?.current?.stop();
                clearAction?.();
                break;

            case 'failCheckOneTimePassword':
                DesktopLayerPopup.notice({
                    message: '인증번호를 잘못 입력하였습니다.<br/>다시 확인 후 입력해 주세요.',
                    buttonLabel: '확인',
                });
                buttonBlock?.current?.stop();
                clearAction?.();
                break;

            default:
                break;
        }
        // eslint-disable-next-line
    }, [action]);

    const checkOneTimePassword = (e) => {
        e.preventDefault();

        const { certificationNumber, complete } = certStatus;
        const { human_mdn, human_name } = user_info;

        if (complete) {
            return;
        }
        if ('' === certificationNumber || '' === human_mdn) {
            return;
        }
        if (!human_name) {
            DesktopLayerPopup.notice({
                message: '이름을 입력 후 다시 시도해 주세요.',
                showXButton: false,
            });
            return;
        }

        checkOneTimePasswordForMemberJoin?.(human_name, human_mdn, certificationNumber);
    };

    const oneTimePassword = (e) => {
        e.preventDefault();

        const { complete } = certStatus;
        const { human_mdn, human_name } = user_info;

        if (complete) {
            return;
        }

        if (!human_name) {
            DesktopLayerPopup.notice({
                message: '이름을 입력 후 다시 시도해 주세요.',
                showXButton: false,
            });
            return;
        }

        if (!human_mdn || !RegExp.NUMBER.test(human_mdn) || human_mdn.length < 10 || human_mdn.length > 11) {
            DesktopLayerPopup.notice({
                message: '휴대전화번호를 확인해주세요.',
                buttonLabel: '확인',
                showXButton: false,
            });
            return false;
        }

        openOneTimePasswordLayerPopup();

        phoneDuplicateCheckAndOneTimePasswordForMemberJoin?.(human_name, human_mdn, true);

        const nextUserInfo = {
            ...user_info,
            cert_human_mdn: human_mdn,
        };
        setUserInfo(nextUserInfo);
    };

    const onBlurCertificationNumber = (e) => {
        e.preventDefault?.();
        onChangeCertStatus?.({
            certificationNumber: e.target.value,
        });
    };

    const searchZipCode = (e) => {
        e.preventDefault();
        layerPopupKeyRef.current = DesktopLayerPopup.modal(
            <PostNumber
                onClose={onCloseLayerPopup}
                onSelect={(selected) => {
                    setLocalUserInfo((prev) => ({
                        ...prev,
                        zip: selected.zip,
                        address: selected.addr,
                    }));
                    const nextUserInfo = {
                        ...user_info,
                        human_address: selected.addr,
                        human_postal_code: selected.zip,
                    };
                    setUserInfo(nextUserInfo);
                }}
            />
        );
    };

    const onCloseLayerPopup = () => {
        if (layerPopupKeyRef.current) {
            DesktopLayerPopup.hide(layerPopupKeyRef.current);
        }
    };

    const onChangeUserInfo = (e) => {
        const name = e.target.value?.trim() ?? '';
        setLocalUserInfo((prev) => ({
            ...prev,
            [e.target.name]: name,
        }));
    };

    const onBlurUserInfo = (e) => {
        const name = e.target.value?.trim() ?? '';
        const nextUserInfo = {
            ...user_info,
            [e.target.name]: name,
        };
        setUserInfo(nextUserInfo);
    };

    const timeoutCallback = () => {
        DesktopLayerPopup.notice({
            message: '인증 유효시간을 초과하였습니다. <br />다시 인증번호 발송 버튼을 눌러주세요.',
        });
        setTimerOn(false);
    };

    const openOneTimePasswordLayerPopup = () => {
        const { human_mdn, human_name } = user_info;

        return DesktopLayerPopup.confirm({
            message: <OnetimeConfirmContent />,
            buttonLabel1: '문자로 다시 받기',
            callback: (type) => {
                if ('CANCEL' === type) {
                    phoneDuplicateCheckAndOneTimePasswordForMemberJoin?.(human_name, human_mdn, false);
                }
            },
        });
    };

    const { onTimePasswordCount = 0, complete = false } = certStatus;

    return (
        <section id="ShippingAddress" style={{ marginBottom: 0 }}>
            <div className="hgroup">
                <h1 className="no-line title">배송 정보 입력</h1>
            </div>
            <table className="form">
                <caption />
                <tbody>
                    <tr>
                        <th scope="row">
                            학부모님 성함<em>필수</em>
                        </th>
                        <td>
                            <fieldset className="name">
                                <input
                                    type="text"
                                    name="human_name"
                                    value={userInfo?.human_name ?? ''}
                                    title="학부모님 성함 입력"
                                    placeholder="학부모님 성함 입력"
                                    onChange={onChangeUserInfo}
                                    onBlur={onBlurUserInfo}
                                />
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            휴대전화번호
                            <em>필수</em>
                        </th>
                        <td>
                            <fieldset className="phone">
                                <legend>휴대전화번호 입력</legend>
                                <div className="item">
                                    <input
                                        style={{ marginRight: 7 }}
                                        type="text"
                                        name="human_mdn"
                                        title="휴대전화번호 입력"
                                        placeholder="휴대전화번호 입력 (- 생략)"
                                        value={userInfo?.human_mdn ?? ''}
                                        onChange={onChangeUserInfo}
                                        onBlur={onBlurUserInfo}
                                        disabled={complete}
                                        className={`${complete ? 'disabled' : ''}`}
                                    />
                                    <a
                                        href="#"
                                        className={`btn-type2 confirm-num ${complete ? '' : 'on'}`}
                                        id="apply-study-certification"
                                        onClick={oneTimePassword}
                                    >
                                        {onTimePasswordCount === 0 ? '인증번호 발송' : '인증번호 재발송'}
                                    </a>
                                </div>
                                <div className="item">
                                    <input
                                        type="text"
                                        maxLength="6"
                                        className={`confirm ${onTimePasswordCount === 0 || complete ? 'disabled' : ''}`}
                                        placeholder={complete ? '인증번호 입력완료' : '인증번호 입력'}
                                        onBlur={onBlurCertificationNumber}
                                        disabled={onTimePasswordCount === 0 || complete}
                                    />
                                    <Timer
                                        format={'mm:ss'}
                                        resetId={onTimePasswordCount}
                                        on={timerOn}
                                        timeoutCallback={timeoutCallback}
                                    />
                                    <a
                                        href="#"
                                        className={`btn-type2 confirm-num ${complete ? '' : 'on'}`}
                                        onClick={complete ? undefined : checkOneTimePassword}
                                    >
                                        {complete ? '인증 완료' : '인증번호 확인'}
                                    </a>
                                    <p className="notice">
                                        회원가입 완료 후 휴대전화번호를 아이디처럼 사용 가능합니다.
                                    </p>
                                </div>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            주소<em>필수</em>
                        </th>
                        <td>
                            <fieldset className="address">
                                <legend>주소 입력</legend>
                                <div className="item">
                                    <input
                                        type="text"
                                        title="우편번호"
                                        className="post disabled"
                                        disabled
                                        value={userInfo.human_postal_code ? userInfo.human_postal_code : ''}
                                        ref={(ref) => {
                                            inputRef.current.human_postal_code = ref;
                                        }}
                                    />
                                    <a href="#" className="btn-type form" onClick={searchZipCode}>
                                        우편번호 찾기
                                    </a>
                                    <input
                                        type="text"
                                        title="주소 입력"
                                        className="disabled display-block"
                                        disabled
                                        value={userInfo.human_address ? userInfo.human_address : ''}
                                        ref={(ref) => {
                                            inputRef.current.human_address = ref;
                                        }}
                                    />
                                    <span className="component-text-form">
                                        <input
                                            type="text"
                                            onChange={onChangeUserInfo}
                                            onBlur={onBlurUserInfo}
                                            name="human_detail_address"
                                            defaultValue={
                                                userInfo.human_detail_address ? userInfo.human_detail_address : ''
                                            }
                                            title="상세 주소 입력"
                                            placeholder="상세 주소 입력"
                                            maxLength="100"
                                            ref={(ref) => {
                                                inputRef.current.human_detail_address = ref;
                                            }}
                                        />
                                    </span>
                                </div>
                                <p className="notice">학습기 및 교재 배송을 위해 정확한 주소를 입력해 주세요.</p>
                            </fieldset>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    );
};

export default ShippingAddressNotLogin;
